import StaticContentsContainer from '../components/StaticContentsContainer';
import medicineRobot from '../../../../assets/images/test/medicine-robot.png';

function MedicineDeliveryRobotDescription() {
    const container = StaticContentsContainer();
    container.classList.add('robot-description');
    container.innerHTML = `
    <h2>약제 배송 로봇</h2>
    <div class="robot-img-container">
        <div class="robot-img">
            <img src="${medicineRobot}" alt="medicine delivery robot">
        </div>
    </div>
    <ul class="robot-description-list">
        <li class="robot-description-item">로봇에 약제를 수납, 수거하는 프로세스 변경에 대한 직원들의 동의가 필요합니다.</li>
        <li class="robot-description-item">배송할 약제의 종류에 따라 업무 프로세스가 다를 수 있습니다.</li>
        <li class="robot-description-item">소형 배송 로봇 1대는 한번에 3~4군데 목적지 배송 가능합니다. 초기에는 수요가 높고 주행이 쉬운 목적지부터 시작하기를 추천합니다.</li>              
    </ul>
    `;
    return container;
}

export default MedicineDeliveryRobotDescription;
